module.exports = __webpack_public_path__ + "img/Roboto-Regular.8681f43.svg";